@use '../../styling/colors.scss' as *;

.NoOptionsPlaceholder {
  display: grid;
  text-align: center; // ETD-1673
  justify-content: center;
  justify-items: center;
  padding: 19px 16px;
}

.NoOptionsPlaceholderWithIcon {
  @extend .NoOptionsPlaceholder;

  row-gap: 12px;
}
